import { InjectionToken, inject } from '@angular/core';
import { FIREBASE_APP, FIREBASE_APP_CHECK } from '../core/firebase.providers';
import { Auth, getAuth } from 'firebase/auth';

export const FIREBASE_AUTH = new InjectionToken<Auth>('Firebase Auth', {
  providedIn: 'root',
  factory: () => {
    // App Check must initialize before Auth starts using Firebase services.
    inject(FIREBASE_APP_CHECK);
    return getAuth(inject(FIREBASE_APP));
  },
});
